export class PharmacieDto {

    id: number;
    login: string;
    cip: number;
    emailPhie: string;
    emailTitulaire: string;
    telPhie: string;
    telTitulaire: string;
    finess: string;
    nomPhie: string;
    nomTitulaire: string;
    prenomTitulaire: string;
    codePostal: string;
    notifMailPhie: boolean;
    notifMailPhien: boolean;
    notifSms: boolean;
    notifSmsPhie: boolean;
    sapId: number;
    codeSogiphar: string;
    actif: boolean; //autorisation de l'envoi d'ordonnances

    constructor() {
    }
  
    public static fromJson(json: Object): PharmacieDto {
      
      return new PharmacieDto()
      .setId(json['id'])
      .setLogin(json['login'])
      .setCip(json['cip'])
      .setEmailPhie(json['email_phie'])
      .setEmailTitulaire(json['email_titulaire'])
      .setTelPhie(json['tel_phie'])
      .setTelTitulaire(json['tel_titulaire'])
      .setFiness(json['finess'])
      .setNomPhie(json['nom_phie'])
      .setNomTitulaire(json['nom_titulaire'])
      .setPrenomTitulaire(json['prenom_titulaire'])
      .setCodePostal(json['code_postal'])
      .setNotifMailPhie(json['notif_mail_phie'])
      .setNotifMailPhien(json['notif_mail_phien'])
      .setNotifSmsPhie(json['notif_sms_phie'])
      .setNotifSms(json['notif_sms'])
      .setSapId(json['sap_id'])
      .setCodeSogiphar(json['code_sogiphar'])
      .setActif(json['actif']);



    }
  
    setId(id: number) {
      this.id = id;
      return this;
    }
  
    setLogin(login: string) {
      this.login = login;
      return this;
    }

    setCip(cip: number) {
      this.cip = cip;
      return this;
    }

    setEmailPhie(emailPhie: string) {
      this.emailPhie = emailPhie;
      return this;
    }

    setEmailTitulaire(emailTitulaire: string) {
      this.emailTitulaire = emailTitulaire;
      return this;
    }

    setTelPhie(telPhie: string) {
      this.telPhie = telPhie;
      return this;
    }

    setTelTitulaire(telTitulaire: string) {
      this.telTitulaire = telTitulaire;
      return this;
    }

    setFiness(finess: string) {
      this.finess = finess;
      return this;
    }

    setNomPhie(nomPhie: string) {
      this.nomPhie = nomPhie;
      return this;
    }

    setNomTitulaire(nomTitulaire: string) {
      this.nomTitulaire = nomTitulaire;
      return this;
    }

    setPrenomTitulaire(prenomTitulaire: string) {
      this.prenomTitulaire = prenomTitulaire;
      return this;
    }

    setCodePostal(codePostal: string) {
      this.codePostal = codePostal;
      return this;
    }

    setNotifMailPhie(notifMailPhie: boolean) {
      this.notifMailPhie = notifMailPhie;
      return this;
    }

    setNotifMailPhien(notifMailPhien: boolean) {
      this.notifMailPhien = notifMailPhien;
      return this;
    }

    setNotifSmsPhie(notifSmsPhie: boolean) {
      this.notifSmsPhie = notifSmsPhie;
      return this;
    }

    setNotifSms(notifSms: boolean) {
      this.notifSms = notifSms;
      return this;
    }

    setSapId(sapId: number) {
      this.sapId = sapId;
      return this;
    }

    setCodeSogiphar(codeSogiphar: string) {
      this.codeSogiphar = codeSogiphar;
      return this;
    }

    setActif(actif: boolean){
      this.actif = actif;
      return this;
    }
  
  }
  